import React from 'react'

import ApprovedTable from './table/approved'
import PendingTable from './table/pending'

import debounce from 'debounce'

import {
    Row,
    Col,
    Card,
    Input
} from 'antd'

import {
    _getAds
} from '../../services'


const _default = {
    data: [],
    page: 1,
    pageSize: 10,
    total: 0,
    searchParam: '',
    loading: false
}

const PENDING = 'pending'
const APPROVED = 'approved'

class EezeeAds extends React.Component {
    render(){
        
        const { 
            pending,
            approved
        } = this.state

        return (
            <div style={{ margin: 16 }}>
                <Row 
                gutter={16}
                type="flex">
                    <Col span={12}>
                        <Card title="Pending Approval">
                            <Input
                                style={{
                                    marginBottom: 12
                                }}
                                placeholder={"Search"}
                                onChange={(e)=>this.handleSearch(PENDING, e.target.value)}
                            />
                            <PendingTable
                                {...pending}
                            />
                        </Card>
                    </Col>        
                    <Col span={12}>
                        <Card title="Approved">
                            <Input
                                style={{
                                    marginBottom: 12
                                }}
                                placeholder={"Search"}
                                onChange={(e)=>this.handleSearch(APPROVED, e.target.value)}
                            />
                            <ApprovedTable
                                {...approved}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }

    constructor(props){
        super(props)

        this.state = {
            
            approved: _default,

            pending: _default
        }

        this.getAdsDebounced = debounce(this.getAdsDebounced, 400)


    }

    componentDidMount(){
        this.getAds(PENDING)
        this.getAds(APPROVED)
    }

    getAds = (key) => {

        if( key !== PENDING && key !== APPROVED ){
            return
        }

        this.setState({
            [key]: {
                ...this.state[key],
                loading: true
            }
        })

        /** object in state */
        const stateObj = this.state[key]

        const { 
            page,
            pageSize,
            searchParam,        
        } = stateObj

        _getAds({ 
            approved: key === APPROVED,
            page,
            pageSize,
            searchParam
        })
        .then( res => {

            const { ads, total } = res.data

            this.setState({
                [key]: {
                    ...this.state[key],
                    data: ads,
                    total,
                    loading: false
                }
            })

        })
    }

    handleSearch = (key, searchParam) => {

        if( key !== PENDING && key !== APPROVED ){
            return
        }

        this.setState({
            [key]: {
                ...this.state[key],
                searchParam
            }
        }, ()=>this.getAdsDebounced(key) )

    }

    getAdsDebounced = (key) => {
        this.getAds(key)
    }

}

export default EezeeAds


// WEBPACK FOOTER //
// ./src/components/eezee-ads/index.js